<script>
    import Field from './Field.svelte';

    export let fields;
    export let data;
    export let errors = {};

    export let field_class;

    function check_prereqs(field) {
        // !(field.preq && (field.preq.value || data[field.preq.field] != field.preq.value))
        if (field.preq && field.preq.value && data[field.preq.field] != field.preq.value) {
            return false
        }
        return true
    }
</script>

{#each fields as field}
    {#if !(field.type == "hidden") && check_prereqs(field)}
        <Field {...field} bind:value={data[field.name]} {errors} preq_value={data[field.preq?.field]} {field_class} on:change on:blur />
    {/if}
{/each}